<template>
    <component :is="version"></component>
</template>

<script>

export default {
    name: 'Account',
    computed: {
        version() {
            return 'WideAccount';
        },
    },
    components: {
        WideAccount: () => import('../components/account/WideAccount'),
    },
};
</script>
